'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _styled = _interopDefault(require('@emotion/styled-base'));
var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');
var toFixed = require('./to-fixed.js');

function capVelocity(maxVelocity, velocity) {
  var direction = velocity < 0 ? -1 : 1;
  return Math.min(Math.abs(velocity), maxVelocity) * direction;
}

var INITIAL_STATE = {
  containerWidth: 0,
  contentWidth: 0,
  offset: 0,
  position: null,
  scrolling: false,
  velocity: 0
};
var SCROLLING_CHANGED = 'SCROLLING_CHANGED';
var SCROLLING_STARTED = 'SCROLLING_STARTED';
var SCROLLING_STOPPED = 'SCROLLING_STOPPED';
var CONTAINER_RESIZED = 'CONTAINER_RESIZED';
var CONTENT_RESIZED = 'CONTENT_RESIZED';

function getThumbWidth(state) {
  if (state.contentWidth === 0) {
    return 0;
  }

  return Math.min(state.containerWidth / state.contentWidth * 100, 100);
}

function getScrollMultiplier(state) {
  var thumbWidth = getThumbWidth(state);

  if (thumbWidth === 0) {
    return 0;
  }

  return 100 / thumbWidth;
}

function getThumbOffset(state) {
  if (state.contentWidth === 0) {
    return 0;
  }

  var scrollMultiplier = getScrollMultiplier(state);
  var maxOffset = state.contentWidth - state.containerWidth;
  var offset = Math.max(0, Math.min(state.offset, maxOffset));
  return offset / state.contentWidth * 100 * scrollMultiplier;
}

function reducer(state, action) {
  switch (action.type) {
    case CONTAINER_RESIZED:
      {
        return __chunk_1.objectSpread2({}, state, {
          containerWidth: action.payload.width
        });
      }

    case CONTENT_RESIZED:
      {
        return __chunk_1.objectSpread2({}, state, {
          contentWidth: action.payload.width
        });
      }

    case SCROLLING_STARTED:
      {
        return __chunk_1.objectSpread2({}, state, {
          offset: action.payload.offset,
          position: action.payload.position,
          scrolling: true,
          velocity: 0
        });
      }

    case SCROLLING_CHANGED:
      {
        if (action.payload.nextOffset != null) {
          if (state.scrolling) {
            return state;
          }

          return __chunk_1.objectSpread2({}, state, {
            offset: action.payload.nextOffset
          });
        }

        if (action.payload.inertia) {
          // scroll offset must be integer
          var _offset = Math.round(state.offset + state.velocity);

          var velocity = toFixed.toFixed(2, state.velocity * action.payload.inertia);
          return __chunk_1.objectSpread2({}, state, {
            offset: _offset,
            velocity: velocity
          });
        }

        if (!state.scrolling) {
          return state;
        }

        var prevOffset = state.offset;
        var prevPosition = state.position;
        var multiplier = getScrollMultiplier(state);
        var position = action.payload.position;
        var offset = prevOffset + (position - prevPosition) * multiplier;
        return __chunk_1.objectSpread2({}, state, {
          offset: offset,
          position: position,
          velocity: offset - prevOffset
        });
      }

    case SCROLLING_STOPPED:
      {
        if (!state.scrolling) {
          return state;
        }

        return __chunk_1.objectSpread2({}, state, {
          scrolling: false,
          velocity: capVelocity(action.payload, state.velocity)
        });
      }

    default:
      {
        return state;
      }
  }
}

function useReducer() {
  var _React$useReducer = React__default.useReducer(reducer, INITIAL_STATE),
      _React$useReducer2 = __chunk_1.slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var actions = React__default.useMemo(function () {
    function decelerate(inertia) {
      dispatch({
        type: SCROLLING_CHANGED,
        payload: {
          inertia: inertia
        }
      });
    }

    function move(position) {
      dispatch({
        type: SCROLLING_CHANGED,
        payload: {
          position: position
        }
      });
    }

    function resizeContainer(width) {
      dispatch({
        type: CONTAINER_RESIZED,
        payload: {
          width: width
        }
      });
    }

    function resizeContent(width) {
      dispatch({
        type: CONTENT_RESIZED,
        payload: {
          width: width
        }
      });
    }

    function scroll(nextOffset) {
      dispatch({
        type: SCROLLING_CHANGED,
        payload: {
          nextOffset: nextOffset
        }
      });
    }

    function start(offset, position) {
      dispatch({
        type: SCROLLING_STARTED,
        payload: {
          offset: offset,
          position: position
        }
      });
    }

    function stop(maxVelocity) {
      dispatch({
        type: SCROLLING_STOPPED,
        payload: maxVelocity
      });
    }

    return {
      decelerate: decelerate,
      move: move,
      resizeContainer: resizeContainer,
      resizeContent: resizeContent,
      scroll: scroll,
      start: start,
      stop: stop
    };
  }, [dispatch]);
  return [state, actions];
}

var ScrollableRowWrapper = _styled("div", {
  target: "eejracj0"
})(process.env.NODE_ENV === "production" ? {
  name: "1n67cu",
  styles: "-ms-overflow-style:none;-webkit-overflow-scrolling:touch;overflow-y:scroll;overflow-y:-moz-scrollbars-none;&::-webkit-scrollbar{display:none;}@supports (scrollbar-width:none){scrollbar-width:none;}"
} : {
  name: "1n67cu",
  styles: "-ms-overflow-style:none;-webkit-overflow-scrolling:touch;overflow-y:scroll;overflow-y:-moz-scrollbars-none;&::-webkit-scrollbar{display:none;}@supports (scrollbar-width:none){scrollbar-width:none;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
});
/**
 * Component that renders content scrollable horizontally.
 *
 * @param {Object} props
 * @param {Function} props.scrollBar
 *   Component to be rendered as a scroll bar. Must accept following props to
 *   be rendered and function correctly:
 *     - `offset` - number representing thumb shift in percents. Designed to be
 *       passed to CSS `translateX`
 *     - `width` - number representing thumb width in percents.
 *     - `onThumbMouseDown` - `mousedown` event handler to be passed as
 *       `onMouseDown` prop to thumb component inside scroll bar.
 */


function ScrollableRow(props) {
  var ref = React__default.useRef(null);

  var _useReducer = useReducer(),
      _useReducer2 = __chunk_1.slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      actions = _useReducer2[1];
  /**
   * Initialize scroll capturing
   */


  var handleStart = React__default.useCallback(function (position) {
    var node = ref.current;

    if (node) {
      actions.start(node.scrollLeft, position);
    }
  }, [actions, ref]);
  /**
   * Update scroll position based on pointer movement
   */

  var handleMove = React__default.useCallback(function (position) {
    var node = ref.current;

    if (node) {
      actions.move(position);
    }
  }, [actions, ref]);
  var handleFinish = React__default.useCallback(function () {
    actions.stop(props.maxVelocity);
  }, [actions, props.maxVelocity]);
  /* MOUSE HANDLING */

  var handleMouseMove = React__default.useCallback(function (event) {
    handleMove(event.clientX);
  }, [handleMove]);
  var handleMouseUp = React__default.useCallback(function () {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    handleFinish();
  }, [handleFinish]);
  var handleMouseDown = React__default.useCallback(function (event) {
    if (event.button === 1 && window.event != null || event.button === 0) {
      handleStart(event.clientX);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
  }, [handleStart]);
  /* END MOUSE HANDLING */
  // Take care of inertia when scrolling has stopped

  React__default.useEffect(function () {
    if (!state.scrolling && Math.floor(Math.abs(state.velocity)) !== 0) {
      var rafId = window.requestAnimationFrame(function () {
        actions.decelerate(props.drag);
      });
      return function () {
        return window.cancelAnimationFrame(rafId);
      };
    }
  }, [actions, props.drag, state.scrolling, state.velocity]);
  React__default.useEffect(function () {
    var node = ref.current;

    if (node) {
      var isDragging = Math.floor(Math.abs(state.velocity)) !== 0;
      var isScrolling = state.scrolling || isDragging;

      if (isScrolling && node.scrollLeft !== state.offset) {
        node.scrollLeft = state.offset;
      }
    }
  }, [state.offset, state.scrolling, state.velocity]);
  React__default.useEffect(function () {
    function handleResize() {
      actions.resizeContainer(ref.current.clientWidth);
      actions.resizeContent(ref.current.scrollWidth);
    }

    if (ref.current) {
      handleResize();
      window.addEventListener('resize', handleResize, true);
      return function () {
        return window.removeEventListener('resize', handleResize, true);
      };
    }
  }, [ref, actions.resizeContainer, actions.resizeContent]);
  React__default.useEffect(function () {
    function handleScroll() {
      actions.scroll(ref.current.scrollLeft);
    }

    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll, true);
      return function () {
        ref.current.removeEventListener('scroll', handleScroll, true);
      };
    }
  }, [ref]);
  var ScrollBar = props.scrollBar;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ScrollableRowWrapper, {
    ref: ref
  }, props.children), React__default.createElement(ScrollBar, {
    offset: getThumbOffset(state),
    width: getThumbWidth(state),
    onThumbMouseDown: handleMouseDown
  }));
}
ScrollableRow.defaultProps = {
  drag: 0.9,
  maxVelocity: 40,
  scrollBar: function scrollBar() {
    return null;
  }
};
ScrollableRow.propTypes = {
  children: PropTypes.node,
  drag: PropTypes.number,
  maxVelocity: PropTypes.number,
  scrollBar: PropTypes.func
};

exports.ScrollableRow = ScrollableRow;
//# sourceMappingURL=scrollable-row.js.map
